import './select-issuer.scss'

import { Select } from 'antd'
import { Row } from 'react-display-flex'
import useSWR from 'swr'

import { fetchByDomain } from '../../api'
import { Issuer } from '../../pages/Issuers/models'
import { getDefaultDomainByEnvironment } from '../../models'
import { getEnvironment } from '../../util/environment'

const { Option } = Select

interface Props {
  onIssuerSelected: (issuerId: number) => void
  issuerKey?: string
}

export const SelectIssuer = ({ onIssuerSelected, issuerKey = 'id' }: Props) => {
  const environment = getEnvironment()
  const { data: issuers } = useSWR<Issuer[]>(['/issuers', getDefaultDomainByEnvironment(environment)], fetchByDomain)

  return (
    <Row className="select-issuer" alignItemsCenter>
      <label htmlFor="select-issuer">Issuer</label>
      <Select
        autoFocus
        showSearch
        id="select-issuer"
        placeholder="Select a issuer"
        optionFilterProp="children"
        filterOption={filterOption}
        onChange={onIssuerSelected}
        allowClear
      >
        {issuers?.map((issuer) => (
          <Option key={issuer?.id} value={issuer[issuerKey]}>
            {`${issuer?.shortName}  ( ${issuer?.code} | ${issuer?.id} )`}
          </Option>
        ))}
      </Select>
    </Row>
  )
}

const filterOption = (searchInput: string, searchOption: any) =>
  searchOption.children.toLowerCase().includes(searchInput.toLowerCase())
